import React, {Component} from 'react';
import IntakeFormRadTextEnum from "./enum/IntakeFormRadTextEnum";
import FormField from "../../../components/form/FormField";
import {PhoneInput, TextInput} from "../../../components";
import {Dropdown} from "primereact/dropdown";
import {connect} from "react-redux";

class IntakeFormRadEmergencyContact extends Component {
    render() {
        const {
            selectedLanguage, readOnly, onChange, pushFormFieldRef, enumLabel,
            emergencyContactName, emergencyContactRelationshipType, emergencyContactPhone
        } = this.props

        return (
            <div className="container dim14-form-row-align">
                <h3 className="text-center mb-3">
                    <b>{IntakeFormRadTextEnum.Emergency_Contact[selectedLanguage]}</b>
                </h3>

                {/* Emergency Contact Name */}
                <div className="row">
                    <div className="col-4 dim14-form-label">
                        {IntakeFormRadTextEnum.Emergency_Contact_Name[selectedLanguage]}:
                    </div>
                    <div className="col-8">
                        <FormField
                            ref={(formField) => pushFormFieldRef(formField)}
                            required
                            requiredMessage={IntakeFormRadTextEnum.Required_Field[selectedLanguage]}
                            validateOn={readOnly ? true : emergencyContactName}
                        >
                            <TextInput
                                className="w-100"
                                value={emergencyContactName}
                                disabled={readOnly}
                                alphabeticOnly
                                onChange={(value) => onChange("emergencyContactName", value)}
                            />
                        </FormField>
                    </div>
                </div>

                {/* Emergency Contact Relationship */}
                <div className="row">
                    <div className="col-4 dim14-form-label">
                        {IntakeFormRadTextEnum.Emergency_Contact_Relationship[selectedLanguage]}:
                    </div>
                    <div className="col-8">
                        <Dropdown
                            className={`DropdownBorderColor w-100 ${
                                readOnly
                                    ? "DropdownDisabledBackground"
                                    : "DropdownBorderColor"
                            }`}
                            value={emergencyContactRelationshipType}
                            disabled={readOnly}
                            options={this.props.relationshipTypes
                                ?.map(r => {
                                    return {label: r[enumLabel] || r.name, value: r}
                                }) || []
                            }
                            displayProperty="label"
                            valueProperty="value"
                            searchEnabled={false}
                            onChange={(event) =>
                                onChange(
                                    "emergencyContactRelationshipType",
                                    event.value
                                )
                            }
                        />
                    </div>
                </div>

                {/* Emergency Contact Phone */}
                <div className="row">
                    <div className="col-4 dim14-form-label">
                        {IntakeFormRadTextEnum.Emergency_Contact_Phone[selectedLanguage]}:
                    </div>
                    <div className="col-8">
                        <FormField
                            ref={(formField) => pushFormFieldRef(formField)}
                            required
                            requiredMessage={IntakeFormRadTextEnum.Required_Field[selectedLanguage]}
                            validateOn={readOnly ? true : emergencyContactPhone}
                        >
                            <PhoneInput
                                containerClass={
                                    readOnly ? "PhoneInputDisabledBackground" : ""
                                }
                                inputClass="w-100"
                                value={emergencyContactPhone}
                                disabled={readOnly}
                                onChange={(value) => onChange("emergencyContactPhone", value)}
                            />
                        </FormField>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        relationshipTypes: state.base.relationshipTypes
    };
}

export default connect(mapStateToProps)(IntakeFormRadEmergencyContact);